define('components/course/models/click-and-reveal-component',[
    "components/course/models/slide-type/base",
    "components/hotspot/collections/hotspot",
    "components/tooltip/collections/tooltip",
    "components/hotspot/models/hotspot",
    "components/tooltip/models/tooltip",
    "components/click-and-reveal-author/models/hotspot-manager",
    "components/click-and-reveal-author/models/base-hotspot",
    "components/word-control/models/word-control-wrapper",
    "components/click-and-reveal-author/models/paragraph-editor-control"
], function(BaseCourseModel, HotspotButtonCollectionClass, TooltipModelCollectionClass, HotspotButtonModelClass, TooltipModelClass, HotspotManagerModel, BaseHotspotManagerModel, WordControlWrapperModel, ParagraphModelClass) {
    'use strict';

    var ClickAndRevealComponentModel = BaseCourseModel.extend({
        "defaults": function() {

            var baseDefaults = BaseCourseModel.prototype.defaults.apply(this, arguments),
                defaults = {

                    /* This property holds count for visited number of hotspots
                     *
                     * @property visitedHotspots
                     * @type {Number}
                     * @default 0
                     */
                    "visitedHotspots": 0,

                    /* This property holds count for total number of hotspots
                     *
                     * @property totalNumberOfHotspots
                     * @type {Number}
                     * @default null
                     */
                    "totalNumberOfHotspots": null,

                    /* This property holds hotspot models collection ref
                     *
                     * @property hotspotCollection
                     * @type {Backbone.Collection}
                     * @default null
                     */
                    "hotspotCollection": null,
                    // data coming from json

                    /* This property holds mode for the interactivity that is display/edit
                     *
                     * @property mode
                     * @type {Number}
                     * @default null
                     */
                    "mode": null,

                    /* This property holds background image of slide
                     *
                     * @property background-image
                     * @type {String}
                     * @default null
                     */
                    "background-image": null,

                    /* This property holds tooltip model array
                     *
                     * @property tooltipModelArray
                     * @type {Array}
                     * @default empty array []
                     */
                    "tooltipModelArray": [],
                    "currentParagraphCount": 0,
                    "currentParagraphTopLeft": {
                        "top": ClickAndRevealComponentModel.NON_INTERACTIVE_TOP_AREA_HEIGHT,
                        "left": 0
                    },
                    "hotspotManagerModel": null,
                    "allHotspotVisitValidation": true,
                    "showCounterToUser": false,
                    "paragraphModelArray": [],
                    "isDECall": true,
                    "globalComponentsData": null
                };

            return _.extend(baseDefaults, defaults);
        },

        /**
         * initialize the click and reveal model and set the default values.
         *
         * @method initialize
         */
        "initialize": function() {

            this._createHotspotModelCollection();
            this._createHotspotManagerModel();
            this._setTotalNumberOfHotspots();
            this._createHotspotModels();
            this._setVisitedHotspots();
        },

        /**
         * set default value of total number of hotspots.
         *
         * @method _setTotalNumberOfHotspots
         * @return {Backbone.Model} reference to current model
         */
        "_setTotalNumberOfHotspots": function() {

            var totalNumberOfHotspots = 0;
            _.each(this.get('hotspotManagerModel').get('hotspots'), function(hotspot) {
                totalNumberOfHotspots += hotspot.tooltips.length;
            });
            this.set('totalNumberOfHotspots', totalNumberOfHotspots);
            return this;
        },

        /**
         * create hotspotmodel Collection and set it.
         *
         * @method _createHotspotModelCollection
         * @return {Backbone.Model} reference to current model
         */
        "_createHotspotModelCollection": function() {

            var hotspotCollection = new HotspotButtonCollectionClass();
            this.set('hotspotCollection', hotspotCollection);
            return this;
        },

        /**
         * create hotspotmodel models and add it to hotspot collection.
         *
         * @method _createHotspotModels
         * @return {Backbone.Model} reference to current model
         */
        "_createHotspotModels": function() {

            var hotspotData = this.get('hotspotManagerModel').get("hotspots"),
                counter = hotspotData.length,
                hotspotCollection = this.get('hotspotCollection'),
                index = 0,
                currentHotspotData = null,
                tooltipModels = null,
                tooltipModelArray = [],
                currentHotspotModel = null,
                PARAGRAPH = BaseHotspotManagerModel.HOTSPOT_TYPE.PARAGRAPH;

            for (; index < counter; index++) {
                currentHotspotData = hotspotData[index];

                // will receive models array and push it into tooltipModelsArray which is a two dimensional Array
                tooltipModels = this._createCurrentHotspotTooltipModels(currentHotspotData.tooltips, currentHotspotData.type);
                tooltipModelArray.push(tooltipModels);
                if (currentHotspotData.type === PARAGRAPH) {
                    currentHotspotData.tooltipModelArray = tooltipModels;
                }
                currentHotspotModel = new HotspotButtonModelClass(currentHotspotData);
                hotspotCollection.add(currentHotspotModel);
            }
            this.set('tooltipModelArray', tooltipModelArray);
            return this;
        },

        /**
         * set visited hotspot count after initialization of hotspot model
         *
         * @method _createHotspotModels
         * @return {Backbone.Model} reference to current model
         */
        "_setVisitedHotspots": function() {

            var hotspotCollection = this.get('hotspotCollection'),
                SELECTED_STATE = HotspotButtonModelClass.STATES.SELECTED,
                visitedHotspots = 0;

            hotspotCollection.each(function(hotspotModel) {
                if (hotspotModel.get('state') === SELECTED_STATE) {
                    visitedHotspots++;
                }
            });
            this.set('visitedHotspots', visitedHotspots);
            return this;
        },

        /**
         * create tooltip model and set it to model attributes.
         *
         * @method _createCurrentHotspotTooltipModels
         * @param {Object} tooltips data of tooltips
         * @return {Array} given hotspot tooltip models
         */
        "_createCurrentHotspotTooltipModels": function(tooltips) {

            var tooltipCount = tooltips.length,
                tooltipsCollection = this._createTooltipCollection(),
                currentTooltipData = null,
                currentTooltipModel = null,
                CONSTANTS = TooltipModelClass.CONSTANTS,
                index = 0;

            for (; index < tooltipCount; index++) {
                currentTooltipData = {
                    "geometry": tooltips[index].bounds,
                    "tooltipConfig": CONSTANTS.TOOLTIP_FIXED_POSITION | CONSTANTS.TOOLTIP_HIDE_ARROW
                };
                currentTooltipModel = new TooltipModelClass(currentTooltipData);
                tooltipsCollection.add(currentTooltipModel);
            }

            return tooltipsCollection;
        },

        "_createTooltipCollection": function() {
            var tooltipCollection = new TooltipModelCollectionClass();
            return tooltipCollection;
        },

        "updateParagraphTopLeft": function(containerHeight, containerWidth, paragraphContainerHeight, paragraphContainerWidth) {
            var currentParagraphTopLeft = this.get('currentParagraphTopLeft'),
                DEFAULT_HOTSPOT_DISTANCE = ClickAndRevealComponentModel.DEFAULT_HOTSPOT_DISTANCE,
                newDimesions = null;

            if (currentParagraphTopLeft.left + paragraphContainerWidth >= containerWidth) {
                newDimesions = {
                    "top": currentParagraphTopLeft.top,
                    "left": currentParagraphTopLeft.left
                };
            } else if (currentParagraphTopLeft.top + paragraphContainerHeight >= containerHeight - ClickAndRevealComponentModel.NON_INTERACTIVE_BOTTOM_AREA_HEIGHT) {

                newDimesions = {
                    "top": currentParagraphTopLeft.top,
                    "left": currentParagraphTopLeft.left + DEFAULT_HOTSPOT_DISTANCE
                };

            } else {
                newDimesions = {
                    "top": currentParagraphTopLeft.top + DEFAULT_HOTSPOT_DISTANCE,
                    "left": currentParagraphTopLeft.left + DEFAULT_HOTSPOT_DISTANCE
                };
            }

            this.set('currentParagraphTopLeft', newDimesions);
        },

        "_createHotspotManagerModel": function() {
            var hotspotManagerModelData = this.get('hotspotManagerModel') || {},
                hotspotManagerModel = null;

            hotspotManagerModel = new HotspotManagerModel(hotspotManagerModelData);
            this.set('hotspotManagerModel', hotspotManagerModel);

            return this;

        },
        "getParagraphModel": function(editorControlData) {

            var paragraphModelArray = this.get('paragraphModelArray'),
                paragraphModel = new ParagraphModelClass(editorControlData);

            paragraphModelArray.push(paragraphModel);
            return paragraphModel;
        },
        "onHotspotVisitComplete": function() {
            this.trigger(ClickAndRevealComponentModel.EVENTS.ALL_HOTSPOTS_VISITED);
        }


    }, {

        "TEXT": {
            "BACKGROUND": "Add background image",
            "HOTSPOT_DROP_DOWN_TITLE": "Hotspot type",
            "ADD_HOTSPOT_BUTTON": "Add hotspot",
            "SAVE_BUTTON": "Save",
            "PREVIEW_BUTTON": "Preview",
            "ADD_PARAGRAPH": "Add Text Paragraph"
        },

        "HOTSPOT_DROP_DOWN": [{
            "optionID": "point-hotspot",
            "optionValue": HotspotManagerModel.HOTSPOT_TYPE.POINT,
            "optionText": "Point Hotspot"
        }, {
            "optionID": "text-hotspot",
            "optionValue": HotspotManagerModel.HOTSPOT_TYPE.TEXT,
            "optionText": "Text Hotspot"
        }, {
            "optionID": "image-hotspot",
            "optionValue": HotspotManagerModel.HOTSPOT_TYPE.IMAGE,
            "optionText": "Image Hotspot"
        }],

        "EVENTS": {
            "ALL_HOTSPOTS_VISITED": "all-hotspots-visited"
        },
        "DEFAULT_HOTSPOT_DISTANCE": 20,
        "NON_INTERACTIVE_TOP_AREA_HEIGHT": 27,
        "NON_INTERACTIVE_BOTTOM_AREA_HEIGHT": 58
    });
    return ClickAndRevealComponentModel;
});

